import HubspotV2PropertiesProvider from 'organization/Event/Services/Apps/HubspotV2/Config/HubspotV2PropertiesProvider'
import TagInput, {
  TagInputProps,
} from 'organization/Event/Services/Apps/HubspotV2/Config/TagInput'
import React from 'react'

export default function HubspoV2TagInput(
  props: Omit<TagInputProps, 'targetTypes'>,
) {
  return (
    <HubspotV2PropertiesProvider>
      <TagInput {...props} targetTypes={['text', 'checkbox']} />
    </HubspotV2PropertiesProvider>
  )
}
